import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { User } from "../models/user";
import api from "./api";

export async function getUser(userId: number): Promise<User> {
    const baseUrl = environment.api.user.get

    const url = baseUrl
        .replace('{userId}', String(userId));

    const response = await api.get(url)
        .then(res => res.data.success);

    return response
}

export async function registerUser(payload): Promise<AsyncResult<number>> {
    const url = environment.api.user.create

    const response = await api.post(url, payload)
        .then(resp => resp?.data.success)
        .catch(() => null);

    if (!response) return { error: 'Email ou senha incorreto!' }

    return { success: response };
}

export async function updateUser(userId: number, payload): Promise<AsyncResult<number>> {
    const baseUrl = environment.api.user.update

    const copy = JSON.parse(JSON.stringify(payload));
    delete copy.file

    const url = baseUrl
        .replace('{userId}', String(userId));

    const response = await api.put(url, copy)
        .then(resp => { return { success: resp?.data.success, error: void 0 } })
        .catch((error) => { return { success: void 0, error: error.response.data.error } });

    if (response.error) return { error: response.error }

    return { success: response.success };
}

export async function validateNick(userId:number, nick: string): Promise<AsyncResult<User>> {
    const baseUrl = environment.api.user.validateNick;

    const url = baseUrl
        .replace('{nick}', nick)
        .replace('{userId}', String(userId))

    const response = await api.get(url)
        .then(res => { return { success: res.data.success, error: void 0 }})
        .catch((error) => { return { success: void 0, error: error.response.data.error } });

    if (response.error) return { error: response.error }

    return { success: response.success };
}

export async function validateEmail(userId:number, email: string): Promise<AsyncResult<User>> {
    const baseUrl = environment.api.user.validateEmail;

    const url = baseUrl
        .replace('{email}', email)
        .replace('{userId}', String(userId));

    const response = await api.get(url)
        .then(res => { return { success: res.data.success, error: void 0 } })
        .catch((error) => { return { success: void 0, error: error.response.data.error } });

    if (response.error) return { error: response.error }

    return { success: response.success };
}